export const scrollToSection = (path, sectionId) => {
    // Navigate to the specific route
    window.location.href = path;
  
    // Wait for DOM to update, then scroll to the section
    setTimeout(() => {
      const section = document.querySelector(sectionId);
      if (section) {
        section.scrollIntoView({ behavior: 'smooth' });
      }
    }, 100); // Adjust delay if necessary
  };
  